export default __webpack_public_path__ + "static/shackpet_banner_1-b00de8d9a02928f3c32607606a260e55.jpg";